import { render, staticRenderFns } from "./Shoes.vue?vue&type=template&id=2a29e7b4&scoped=true&"
import script from "./Shoes.vue?vue&type=script&lang=js&"
export * from "./Shoes.vue?vue&type=script&lang=js&"
import style0 from "./Shoes.vue?vue&type=style&index=0&id=2a29e7b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a29e7b4",
  null
  
)

export default component.exports